import {AcoesColunaPrincipal} from './acoes-coluna-principal';

export class ColunasListPaginator {
  nameHeader: string;
  nameColumn: string;
  widthColumn: string;
  maxWidthColumn?: string;
  isBooleano?: boolean;
  disableSort?: boolean;
  isIcone?: boolean;
  columnTooltipIcone?: (item: any) => string;
  customColor?: string;
  cellAlign?: string;
  valor?: (value) => any;
  valorInner?: (value) => string;
  icone?: (item: any) => string;
  style?: (value) => string;
  acao?: AcoesColunaPrincipal;
  sortName?: string;
}
